"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sampleUpdateBody = void 0;
const util_1 = require("../../util");
const samples_1 = require("../samples");
exports.sampleUpdateBody = (0, util_1.objectSchema)({
    value: samples_1.sampleSchemaDef.wholeSample,
});
